import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { eDischargeType, Order, OrderManagerService, ValidationProblem, ValidationService } from 'reg-hub-common';
import { SteppedComponent } from 'projects/reg-hub-client/src/interfaces/stepped-component';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-discharge-review',
    templateUrl: './discharge-review.component.html',
    styleUrls: ['./discharge-review.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DischargeReviewComponent extends SteppedComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() printMode: boolean = false;

  shouldShowAdditionalInformation: boolean = false;

  constructor(orderManager: OrderManagerService,
    validationService: ValidationService) {
    super(orderManager, validationService);
  }

  protected override init(order: Order): void {
    super.init(order);

    this.validationService.currentValidation$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(validation => this.validation$.next(validation));
  }

  override ngOnDestroy(): void {
    this.validationService.clearValidation();
    super.ngOnDestroy();
  }

  public override onSaving(): void {
    
  }

  public override pushErrors(errors: ValidationProblem[] | undefined): void {
    
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return (errors?.length ?? 0) === 0 ? StepValidationState.ValidationSuccess : StepValidationState.ValidationError;
  }

  isHistorical(): boolean {
    return this.order.orderStatusTypeID.includes('Historical');
  }

  protected getExpiryDateHeader(): string {
    return this.transloco.translate(this.isHistorical() ? 'orders.expiryDateLabel' : 'orders.requestedExpiryDateLabel');
  }
}